import AnalyzeAnalysis from "./AnalyzeAnalysis.jsx";

export default AnalyzeAnalysis;



// WEBPACK FOOTER //
// ./src/components/pages/Create/universe_lite/Analyze/analysis/index.js